export interface JsonApiErrorObject {
  status?: number | string
  title?: string
  detail?: string
  code?: string
  source?: {
    pointer?: string
    header?: string
    parameter?: string
  }
  meta?: unknown
}

export class ApiError extends Error {
  public readonly error: JsonApiErrorObject
  constructor(error: JsonApiErrorObject) {
    super(error.detail || error.title || 'API Error')
    this.error = error
  }
}
